module.exports = __webpack_public_path__ + "static/media/avatar-4.6adb0c09.jpg";